import { Icon } from '@mdi/react';
import { sendIt } from 'gatsby-plugin-purina-analytics/common/functions';
import React from 'react';
import { mdiAddOutline } from 'src/assets/icons/mdiIcons';
import { getMedia } from 'src/utils/mediaHelpers';

type Props = {
  componentName: string;
  name: string;
  markerMedia?: Media;
  style?: React.CSSProperties;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  children?: React.ReactNode;
};

const HotspotTrigger = React.forwardRef<HTMLButtonElement, Props>(
  ({ name, markerMedia, style, onClick, children, componentName, ...rest }, ref) => {
    return (
      <button
        ref={ref}
        type="button"
        onClick={e => {
          sendIt({
            event: 'module_interaction',
            eventParams: {
              component_id: componentName,
              component_type: 'hot_spot',
              content_name: name,
            },
          });

          onClick?.(e);
        }}
        className="pds-absolute pds-flex pds-h-[44px] pds-w-[44px] -pds-translate-x-1/2 -pds-translate-y-1/2 pds-items-center pds-justify-center pds-overflow-hidden pds-rounded-circle pds-transition-transform hover:pds-scale-125 focus:pds-scale-125 active:pds-scale-125 data-[state=open]:pds-scale-125"
        style={style}
        {...rest}
      >
        {children}
        <span className="pds-sr-only">{name}</span>
        {markerMedia &&
          getMedia({
            media: markerMedia,
            alt: '',
            width: 36,
            height: 36,
          })}
        {!markerMedia && (
          <Icon
            // @ts-ignore - width
            width={24}
            aria-hidden="true"
            className="pds-ml-2 pds-mt-1 [&_path]:pds-text-white"
            path={mdiAddOutline}
            // @ts-ignore - A11y Requirement
            role={undefined}
          />
        )}
      </button>
    );
  },
);

export { HotspotTrigger };
